import { Message, ScheduledMessage } from 'src/models/Message'
import { RoomType } from 'src/models/Room'
import useSWR from 'swr'
import useSWRInfinite from 'swr/infinite'
import { toScheduledMessage } from '.'
import { ApiClient } from '../client'
import { GET_SCHEDULED_SENDING_MESSAGES } from '../endpoints'
import { Messages, ScheduledSendingMessages } from '../types/message'
import { toMessage } from './converters'

const messageFetcher = async (
  url: string,
  page: number,
): Promise<Message[]> => {
  if (!url) return []
  const res = await ApiClient.get<Messages>(
    `${url}${url.includes('?') ? '&' : '?'}page=${page + 1}`,
  )
  if (res.error) throw res.error

  const messages: Message[] = res.data ? res.data.messages.map(toMessage) : []
  return messages
}

export const useMessages = (url: string) =>
  useSWRInfinite<Message[]>(
    (index, prevData) => (prevData && !prevData.length ? null : [url, index]),
    messageFetcher,
  )

const scheduledMessageFetcher = async (
  url: string,
  roomType: RoomType | undefined,
  roomId: number | undefined,
) => {
  if (!url || !roomType || !roomId) return []
  const res = await ApiClient.get<ScheduledSendingMessages>(
    `${url}?room_type=${roomType}&id=${roomId}`,
  )
  const messages: ScheduledMessage[] = res.data
    ? res.data.scheduledSendingMessages.map(toScheduledMessage)
    : []
  return messages
}

export const useScheduledMessages = (
  roomType: RoomType | undefined,
  roomId: number | undefined,
) =>
  useSWR(
    [GET_SCHEDULED_SENDING_MESSAGES, roomType, roomId],
    scheduledMessageFetcher,
  )
